export function geomForPoints([x1, y1]: readonly number[], [x2, y2]: readonly number[], [x3, y3]: readonly number[]) {
    const wx = x2 - x1;
    const wy = y2 - y1;
    const width = Math.sqrt(wx * wx + wy * wy);

    const hx = x3 - x2;
    const hy = y3 - y2;
    const height = Math.sqrt(hx * hx + hy * hy);
    const angle = wx < 0 ? Math.PI + Math.atan(wy / wx) : Math.atan(wy / wx);
    return { width, height, angle };
}

export function rotatePointAboutAngleRelative([x, y]: readonly number[], angle: number, [ox, oy]: readonly number[]) {
    const tx = x - ox;
    const ty = y - oy;
    const rx = Math.cos(angle) * tx - Math.sin(angle) * ty;
    const ry = Math.sin(angle) * tx + Math.cos(angle) * ty;
    return [rx, ry];
}

export function pointInBox(
    xy: readonly number[],
    xy1: readonly number[],
    xy2: readonly number[],
    xy3: readonly number[]
): boolean {
    const { width, height, angle } = geomForPoints(xy1, xy2, xy3);
    const [rx, ry] = rotatePointAboutAngleRelative(xy, -angle, xy1);
    if (0 <= rx && rx < width) {
        if (height < 0) {
            return height < ry && ry <= 0;
        } else {
            return 0 <= ry && ry < height;
        }
    }
    return false;
}

export type UnanchoredBox = { width: number; height: number };
export type AnchoredBoxToScale = UnanchoredBox & { x: number; y: number; scale: number };

export function fitBoxIntoBox(givenBox: UnanchoredBox, containerBox: UnanchoredBox): AnchoredBoxToScale {
    const givenRatio = givenBox.width / givenBox.height;
    const containerRatio = containerBox.width / containerBox.height;

    if (givenRatio > containerRatio) {
        const scale = containerBox.width / givenBox.width;
        const width = containerBox.width;
        const height = givenBox.height * scale;
        return {
            x: 0,
            y: (containerBox.height - height) / 2,
            width,
            height,
            scale,
        };
    } else {
        const scale = containerBox.height / givenBox.height;
        const width = givenBox.width * scale;
        const height = containerBox.height;
        return {
            x: (containerBox.width - width) / 2,
            y: 0,
            width,
            height,
            scale,
        };
    }
}
